export default function toggleFilterList() {
  const filterToggle = document.querySelectorAll("[data-toggle-filter]");

  for (let i = 0; i < filterToggle.length; i++) {
    filterToggle[i].addEventListener("click", () => {
      const filterSelector = filterToggle[i].getAttribute("data-toggle-filter");
      const filterContainer = document.getElementById(filterSelector);

      if (filterContainer) {
        filterToggle[i].classList.toggle("open");
        filterContainer.classList.toggle("open");
      }
    });
  }
}
